import { useGet } from '../../../../api';
import { useEffect } from 'react';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';
import { convertToQueryParams } from '../utils';
import { downloadFile } from '../../../../components/utils';

export type ReportDto = {
    responseId: string;
};

export const useGetReport = <T extends {}>(
    endpoint: string,
    filters: T,
    sorting?: { direction: 'asc' | 'desc'; field: string },
) => {
    const { data, fetchData, loading } = useGet<ReportDto>({
        enabled: false,
        queryParams: convertToQueryParams({ ...filters, ...(sorting ? sorting : {}) }),
        url: `${ACCESS_ANALYSIS_BASE_URL}/${endpoint}/generateReport`
    });

    useEffect(() => {
        const responseId = data?.responseId;

        if (!loading && responseId) {
            downloadFile(`${ACCESS_ANALYSIS_BASE_URL}/downloadReport/${responseId}`);
        }
    }, [data?.responseId, loading]);

    return {
        downloadReport: fetchData,
        downloadingReport: loading
    };
};
